import { jsxs as _, jsx as s } from "react/jsx-runtime";
import * as d from "react";
import { forwardRef as I, useId as q } from "react";
import { c as R, u as K } from "../index-BAFn5Hvf.js";
import { u as k } from "../index-CCavb-1K.js";
import { c as H, P as v } from "../index-RcgQH_g_.js";
import { c as z, R as T, I as j } from "../index-DSAktXEq.js";
import { u as U } from "../index-BrDAPQgS.js";
import { u as $ } from "../index-D92Twj_n.js";
import { u as X } from "../index-BZPx6jYI.js";
import { P as Y } from "../index-Bl3O8yTo.js";
import { c as b } from "../clsx-OuTLNxxd.js";
var S = "Radio", [J, w] = H(S), [Q, Z] = J(S), C = d.forwardRef(
  (t, r) => {
    const {
      __scopeRadio: e,
      name: n,
      checked: o = !1,
      required: i,
      disabled: c,
      value: u = "on",
      onCheck: l,
      ...f
    } = t, [m, p] = d.useState(null), x = k(r, (h) => p(h)), a = d.useRef(!1), y = m ? !!m.closest("form") : !0;
    return /* @__PURE__ */ _(Q, { scope: e, checked: o, disabled: c, children: [
      /* @__PURE__ */ s(
        v.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": E(o),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: u,
          ...f,
          ref: x,
          onClick: R(t.onClick, (h) => {
            o || l == null || l(), y && (a.current = h.isPropagationStopped(), a.current || h.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ s(
        ee,
        {
          control: m,
          bubbles: !a.current,
          name: n,
          value: u,
          checked: o,
          required: i,
          disabled: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
C.displayName = S;
var P = "RadioIndicator", N = d.forwardRef(
  (t, r) => {
    const { __scopeRadio: e, forceMount: n, ...o } = t, i = Z(P, e);
    return /* @__PURE__ */ s(Y, { present: n || i.checked, children: /* @__PURE__ */ s(
      v.span,
      {
        "data-state": E(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: r
      }
    ) });
  }
);
N.displayName = P;
var ee = (t) => {
  const { control: r, checked: e, bubbles: n = !0, ...o } = t, i = d.useRef(null), c = X(e), u = $(r);
  return d.useEffect(() => {
    const l = i.current, f = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(f, "checked").set;
    if (c !== e && p) {
      const x = new Event("click", { bubbles: n });
      p.call(l, e), l.dispatchEvent(x);
    }
  }, [c, e, n]), /* @__PURE__ */ s(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: e,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...t.style,
        ...u,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function E(t) {
  return t ? "checked" : "unchecked";
}
var oe = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], G = "RadioGroup", [te, ze] = H(G, [
  z,
  w
]), W = z(), A = w(), [ie, re] = te(G), B = d.forwardRef(
  (t, r) => {
    const {
      __scopeRadioGroup: e,
      name: n,
      defaultValue: o,
      value: i,
      required: c = !1,
      disabled: u = !1,
      orientation: l,
      dir: f,
      loop: m = !0,
      onValueChange: p,
      ...x
    } = t, a = W(e), y = U(f), [h, L] = K({
      prop: i,
      defaultProp: o,
      onChange: p
    });
    return /* @__PURE__ */ s(
      ie,
      {
        scope: e,
        name: n,
        required: c,
        disabled: u,
        value: h,
        onValueChange: L,
        children: /* @__PURE__ */ s(
          T,
          {
            asChild: !0,
            ...a,
            orientation: l,
            dir: y,
            loop: m,
            children: /* @__PURE__ */ s(
              v.div,
              {
                role: "radiogroup",
                "aria-required": c,
                "aria-orientation": l,
                "data-disabled": u ? "" : void 0,
                dir: y,
                ...x,
                ref: r
              }
            )
          }
        )
      }
    );
  }
);
B.displayName = G;
var D = "RadioGroupItem", M = d.forwardRef(
  (t, r) => {
    const { __scopeRadioGroup: e, disabled: n, ...o } = t, i = re(D, e), c = i.disabled || n, u = W(e), l = A(e), f = d.useRef(null), m = k(r, f), p = i.value === o.value, x = d.useRef(!1);
    return d.useEffect(() => {
      const a = (h) => {
        oe.includes(h.key) && (x.current = !0);
      }, y = () => x.current = !1;
      return document.addEventListener("keydown", a), document.addEventListener("keyup", y), () => {
        document.removeEventListener("keydown", a), document.removeEventListener("keyup", y);
      };
    }, []), /* @__PURE__ */ s(
      j,
      {
        asChild: !0,
        ...u,
        focusable: !c,
        active: p,
        children: /* @__PURE__ */ s(
          C,
          {
            disabled: c,
            required: i.required,
            checked: p,
            ...l,
            ...o,
            name: i.name,
            ref: m,
            onCheck: () => i.onValueChange(o.value),
            onKeyDown: R((a) => {
              a.key === "Enter" && a.preventDefault();
            }),
            onFocus: R(o.onFocus, () => {
              var a;
              x.current && ((a = f.current) == null || a.click());
            })
          }
        )
      }
    );
  }
);
M.displayName = D;
var ne = "RadioGroupIndicator", O = d.forwardRef(
  (t, r) => {
    const { __scopeRadioGroup: e, ...n } = t, o = A(e);
    return /* @__PURE__ */ s(N, { ...o, ...n, ref: r });
  }
);
O.displayName = ne;
var V = B, F = M, ae = O;
const se = "320px", ce = "600px", de = "1025px", le = "_isVisuallyHidden_17lzy_51", ue = "_radioGroupRoot_17lzy_67", pe = "_radioGroupItem_17lzy_72", xe = "_radioGroupIndicator_17lzy_83", fe = "_label_17lzy_100", g = {
  mobile: se,
  "mobile-wide": "480px",
  tablet: ce,
  "tablet-wide": "800px",
  desktop: de,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: le,
  radioGroupRoot: ue,
  radioGroupItem: pe,
  radioGroupIndicator: xe,
  label: fe
}, me = I(({ className: t, ...r }, e) => /* @__PURE__ */ s(
  V,
  {
    className: b(g.radioGroupRoot, t),
    ...r,
    ref: e
  }
));
me.displayName = V.displayName;
const ye = I(({ className: t, children: r, ...e }, n) => {
  const o = q();
  return /* @__PURE__ */ _(
    "label",
    {
      className: b(g.label, { [g.checked]: e.checked }),
      id: o,
      children: [
        /* @__PURE__ */ s(
          F,
          {
            "aria-labelledby": o,
            ref: n,
            className: b(g.radioGroupItem, t),
            ...e,
            children: /* @__PURE__ */ s(ae, { className: g.radioGroupIndicator })
          }
        ),
        r
      ]
    }
  );
});
ye.displayName = F.displayName;
export {
  me as RadioGroup,
  ye as RadioGroupItem
};
